import { Box } from "@mui/material";
import {
  DataGrid,
  GridToolbarContainer,
  GridToolbarExport,
  useGridApiRef,
} from "@mui/x-data-grid";
import { useEffect, useState } from "react";
// import NorthIcon from "@mui/icons-material/North";
// import SouthIcon from "@mui/icons-material/South";
import { useSelector } from "react-redux";
import CurrencyField from "../../../components/inputs/CurrencyField";

const sumValues = (obj) => Object.values(obj).reduce((a, b) => a + b, 0);

function CustomToolbar() {
  return (
    <GridToolbarContainer>
      <GridToolbarExport
        csvOptions={{
          fileName: `Participación IDE - ${new Date(Date.now()).getDate()}-${
            new Date(Date.now()).getMonth() + 1
          }-${new Date(Date.now()).getFullYear()}`,
          delimiter: ";",
          utf8WithBom: true,
        }}
      />
    </GridToolbarContainer>
  );
}

const InvestorListTable = (props) => {
  const { projects, investors } = props;
  const { list } = useSelector((state) => state.projectAssociates);

  const [cellWidth, setWidth] = useState(150);

  const preColumns = projects.map((project) => ({
    field: project?._id ?? "id",
    headerName: `${project?.isUSD ? "" : "*"} ${project?.alias}` ?? "",
    type: "number",
    width: cellWidth,
    editable: false,
    // headerClassName: "super-app-theme--header",
  }));

  const columns = [
    {
      field: "order",
      headerName: "#",
      width: 20,
      editable: false,
      // headerClassName: "super-app-theme--header",
    },
    // {
    //   field: "id",
    //   headerName: "ID",
    //   width: 70,
    //   editable: false,

    //   // headerClassName: "super-app-theme--header",
    // },
    {
      field: "name",
      headerName: "Nombre",
      width: 190,
      editable: false,
    },
    {
      field: "total",
      headerName: "Total USD",
      type: "number",
      width: 120,
      editable: false,
    },
    ...preColumns,
  ];

  const [rows, setRows] = useState([]);

  const [usdValue, setUsdValue] = useState(20.0);

  const handleChange = (e) => {
    setUsdValue((_) => e.target.rawValue ?? e.target.value);
  };

  useEffect(() => {
    const rows = investors.map((associate, index) => {
      const deProyect = projects.map((project) => {
        const data = list
          .find((mapProject) => mapProject.projectRef === project._id)
          ?.associates?.find(
            (mapAssociante) => mapAssociante.associateRef._id === associate?._id
          );
        return {
          [project._id]: !!data
            ? data?.projectRef.isUSD ?? false
              ? data?.capital ?? 0
              : Number((data?.capital / usdValue).toFixed(0))
            : 0,
        };
      });
      const newData = deProyect.reduce(function (result, item) {
        var key = Object.keys(item)[0]; //first property: a, b, c
        result[key] = item[key];
        return result;
      }, {});
      return {
        order: index + 1,
        id: associate._id,
        name: associate.name,
        total: sumValues(newData),
        ...newData,
      };
    });
    setRows(rows);
  }, [usdValue, list]);

  const apiRef = useGridApiRef();

  return (
    <Box width={"100%"}>
      <Box
        display={"flex"}
        width={"100%"}
        justifyContent={"end"}
        mb={2}
        gap={2}
      >
        <Box width={150}>
          <CurrencyField
            label="USD"
            name="usd"
            value={usdValue}
            onChange={handleChange}
          />
        </Box>
        {/* <Button
          onClick={() => {
            if (cellWidth === 150) {
              setWidth(75);
            } else {
              setWidth(150);
            }
          }}
        >
          {cellWidth === 150 ? "Contraer" : "Expander"}
        </Button> */}
      </Box>
      <Box
        sx={{
          height: 450,
          width: "100%",
          "& .super-app-theme--header": {
            backgroundColor: "rgb(8, 29, 44)",
            color: "white",
          },
          color: "white",
        }}
      >
        <DataGrid
          apiRef={apiRef}
          rows={rows}
          columns={columns}
          density="compact"
          localeText={{
            noRowsLabel: "Sin filas",
            noResultsOverlayLabel: "Resultados no encontrados",

            // Density selector toolbar button text
            toolbarDensity: "Densidad",
            toolbarDensityLabel: "Densidad",
            toolbarDensityCompact: "Compacta",
            toolbarDensityStandard: "Estándar",
            toolbarDensityComfortable: "Cómoda",

            // Columns selector toolbar button text
            toolbarColumns: "Columnas",
            toolbarColumnsLabel: "Seleccionar columnas",

            // Filters toolbar button text
            toolbarFilters: "Filtros",
            toolbarFiltersLabel: "Mostrar filtros",
            toolbarFiltersTooltipHide: "Ocultar filtros",
            toolbarFiltersTooltipShow: "Mostrar filtros",
            toolbarFiltersTooltipActive: (count) =>
              count > 1 ? `${count} filtros activos` : `${count} filtro activo`,

            // Quick filter toolbar field
            toolbarQuickFilterPlaceholder: "Buscar…",
            toolbarQuickFilterLabel: "Buscar",
            toolbarQuickFilterDeleteIconLabel: "Limpiar",

            // Export selector toolbar button text
            toolbarExport: "Exportar",
            toolbarExportLabel: "Exportar",
            toolbarExportCSV: "Descargar como CSV",
            toolbarExportPrint: "Imprimir",
            toolbarExportExcel: "Descargar como Excel",

            // Columns management text
            columnsManagementSearchTitle: "Buscar",
            columnsManagementNoColumns: "Sin columnas",
            columnsManagementShowHideAllText: "Mostrar/Ocultar todas",
            columnsManagementReset: "Restablecer",
            columnsManagementDeleteIconLabel: "Limpiar",

            // Filter panel text
            filterPanelAddFilter: "Agregar filtro",
            filterPanelRemoveAll: "Remover todos",
            filterPanelDeleteIconLabel: "Borrar",
            filterPanelLogicOperator: "Operador lógico",
            filterPanelOperator: "Operadores",
            filterPanelOperatorAnd: "Y",
            filterPanelOperatorOr: "O",
            filterPanelColumns: "Columnas",
            filterPanelInputLabel: "Valor",
            filterPanelInputPlaceholder: "Valor de filtro",

            // Filter operators text
            filterOperatorContains: "contiene",
            filterOperatorDoesNotContain: "no contiene",
            filterOperatorEquals: "es igual",
            filterOperatorDoesNotEqual: "es diferente a",
            filterOperatorStartsWith: "comienza con",
            filterOperatorEndsWith: "termina con",
            filterOperatorIs: "es",
            filterOperatorNot: "no es",
            filterOperatorAfter: "es posterior",
            filterOperatorOnOrAfter: "es en o posterior",
            filterOperatorBefore: "es anterior",
            filterOperatorOnOrBefore: "es en o anterior",
            filterOperatorIsEmpty: "esta vacío",
            filterOperatorIsNotEmpty: "no esta vacío",
            filterOperatorIsAnyOf: "es cualquiera de",
            "filterOperator=": "=",
            "filterOperator!=": "!=",
            "filterOperator>": ">",
            "filterOperator>=": ">=",
            "filterOperator<": "<",
            "filterOperator<=": "<=",

            // Header filter operators text
            headerFilterOperatorContains: "Contiene",
            headerFilterOperatorDoesNotContain: "No contiene",
            headerFilterOperatorEquals: "Es igual a",
            headerFilterOperatorDoesNotEqual: "Es diferente a",
            headerFilterOperatorStartsWith: "Comienza con",
            headerFilterOperatorEndsWith: "Termina con",
            headerFilterOperatorIs: "Es",
            headerFilterOperatorNot: "No es",
            headerFilterOperatorAfter: "Esta después de",
            headerFilterOperatorOnOrAfter: "Esta en o después de",
            headerFilterOperatorBefore: "Esta antes de",
            headerFilterOperatorOnOrBefore: "Esta en o antes de",
            headerFilterOperatorIsEmpty: "Esta vacío",
            headerFilterOperatorIsNotEmpty: "No esta vacío",
            headerFilterOperatorIsAnyOf: "Es cualquiera de",
            "headerFilterOperator=": "Es igual a",
            "headerFilterOperator!=": "Es diferente a",
            "headerFilterOperator>": "Es mayor que",
            "headerFilterOperator>=": "Es mayor o igual que",
            "headerFilterOperator<": "Es menor que",
            "headerFilterOperator<=": "Es menor o igual que",

            // Filter values text
            filterValueAny: "cualquiera",
            filterValueTrue: "verdadero",
            filterValueFalse: "falso",

            // Column menu text
            columnMenuLabel: "Menú",
            // columnMenuAriaLabel: (columnName: string) => `${columnName} column menu`,
            columnMenuShowColumns: "Mostrar columnas",
            columnMenuManageColumns: "Administrar columnas",
            columnMenuFilter: "Filtro",
            columnMenuHideColumn: "Ocultar",
            columnMenuUnsort: "Desordenar",
            columnMenuSortAsc: "Ordenar ASC",
            columnMenuSortDesc: "Ordenar DESC",

            // Column header text
            columnHeaderFiltersTooltipActive: (count) =>
              count > 1 ? `${count} filtros activos` : `${count} filtro activo`,
            columnHeaderFiltersLabel: "Mostrar filtros",
            columnHeaderSortIconLabel: "Ordenar",

            // Rows selected footer text
            footerRowSelected: (count) =>
              count > 1
                ? `${count.toLocaleString()} filas seleccionadas`
                : `${count.toLocaleString()} fila seleccionada`,

            // Total row amount footer text
            footerTotalRows: "Filas Totales:",

            // Total visible row amount footer text
            footerTotalVisibleRows: (visibleCount, totalCount) =>
              `${visibleCount.toLocaleString()} de ${totalCount.toLocaleString()}`,

            // Checkbox selection text
            checkboxSelectionHeaderName: "Seleccionar casilla",
            checkboxSelectionSelectAllRows: "Seleccionar todas las filas",
            checkboxSelectionUnselectAllRows: "Deseleccionar todas las filas",
            checkboxSelectionSelectRow: "Seleccionar fila",
            checkboxSelectionUnselectRow: "Deseleccionar fila",

            // Boolean cell text
            booleanCellTrueLabel: "si",
            booleanCellFalseLabel: "no",

            // Actions cell more text
            actionsCellMore: "más",

            // Column pinning text
            pinToLeft: "Anclar a la izquierda",
            pinToRight: "Anclar a la derecha",
            unpin: "Desanclar",

            // Tree Data
            treeDataGroupingHeaderName: "Grupo",
            treeDataExpand: "mostrar hijos",
            treeDataCollapse: "ocultar hijos",

            // Grouping columns
            groupingColumnHeaderName: "Grupo",
            groupColumn: (name) => `Agrupar por ${name}`,
            unGroupColumn: (name) => `No agrupar por ${name}`,

            // Master/detail
            detailPanelToggle: "Alternar detalle",
            expandDetailPanel: "Expandir",
            collapseDetailPanel: "Contraer",

            // Row reordering text
            rowReorderingHeaderName: "Reordenar filas",

            // Aggregation
            aggregationMenuItemHeader: "Agregación",
            aggregationFunctionLabelSum: "suma",
            aggregationFunctionLabelAvg: "promedio",
            aggregationFunctionLabelMin: "mínimo",
            aggregationFunctionLabelMax: "máximo",
            aggregationFunctionLabelSize: "tamaño",
            MuiTablePagination: {
              labelRowsPerPage: "Columnas por página:",

              labelDisplayedRows: ({ from, to, count }) =>
                `${from} - ${to} de ${count === -1 ? `más de ${to}` : count}`,
            },
          }}
          initialState={{
            pagination: {
              paginationModel: { page: 0, pageSize: 100 },
            },
          }}
          pageSizeOptions={[25, 50, 100]}
          slots={{
            toolbar: CustomToolbar,
            // columnSortedDescendingIcon: NorthIcon,
            // columnSortedAscendingIcon: SouthIcon,
          }}
          sx={{
            "& .MuiDataGrid-columnHeader": {
              backgroundColor: "#081D2C",
              color: "white",
            },
            "& .MuiDataGrid-sortIcon": {
              opacity: 1,
              color: "white",
            },
            "& .MuiDataGrid-menuIconButton": {
              opacity: 1,
              color: "white",
            },
          }}
        />
      </Box>
    </Box>
  );
};

export default InvestorListTable;
